import { Table, useGrid } from "@podtrac/common/grid";
import { useParams } from "react-router-dom";
import styles from "./link-report.module.scss";
import { useLinkReport } from "./use-link-report";
import StackedAreaChart from "./StackedAreaChart";

const dateFormat = Intl.DateTimeFormat().format;
export function LinkReport({ api, config }) {
    const { report } = useParams();
    const { id, title, columns } = config[report] ?? {};
    const { chartData, labels, metric, period, query } = useLinkReport(report, id, api);
    const { isLoading, data: { results, total } = {} } = query;

    const grid = useGrid({
        data: results,
        columns,
        meta: {
            total,
        },
    });

    return (
        <>
            <h2>{title}</h2>

            <StackedAreaChart
                metric={metric}
                period={period}
                data={chartData}
                labels={labels}
                series={d => d[id] ?? "total"}
                date={d => new Date(d.period)}
                value={d => d[metric]}
                //colorScale={colorScale}
            >
                {/*<>
                    <select
                        style={{
                            fontSize: "0.5em",
                            position: "absolute",
                            top: 0,
                            left: 0,
                            margin: "0.75em 0 0 6em"
                        }}
                        value={metric}
                        onChange={event => setMetric(event.target.value)}
                    >
                        {metrics.map(m => (
                            <option key={m.value} value={m.value}>
                                {m.label}
                            </option>
                        ))}
                    </select>
                    <ChartControls data={chartData} config={exportConfig} />
                </>*/}
            </StackedAreaChart>

            <Table grid={grid} className={styles.grid} loading={isLoading} />

            <small style={{ display: "block", marginTop: "2em" }}>Last updated: {total?.calculated ? dateFormat(new Date(total.calculated)) : "pending"}</small>
        </>
    );
}
